import LogoutBtn from "./logout-btn";

export default LogoutBtn;
